import cx from 'classnames'
import React from 'react'

import styles from './index.module.scss'

export function Heading (props) {
  return (
    <h2
      {...props.attributes}
      className={cx(props.attributes.className, styles.heading)}
      style={props.style}
    >
      {props.children}
    </h2>
  )
}
